<div class="modal-header">

  <h5 class="modal-title">

    Attachments

  </h5>

  <div class="d-flex align-items-center gap-3">
    <a class="text-primary cursor-pointer text-decoration-none" (click)="downloadAllAttachments()" 
       style="font-size: 14px; font-weight: 500;"
       *ngIf="files && files?.length > 1">
      <i class="ri-download-2-line me-1"></i>Download All Attachments
    </a>
    <button type="button" class="btn-close" (click)="close()"></button>
  </div>

</div>

<div class="modal-body">

  <ng-container *ngIf="!files || files.length === 0" class="p-2">

    <h6>

      No Files Were Found.

    </h6>

  </ng-container>

  <ng-container *ngIf="files && files.length > 0">

    <div class="list-group">

      <div *ngFor="let file of files; let last = last;"
        class="list-group-item border-0 d-flex align-items-center justify-content-between"
        [class.border-bottom]="!last">

        <div class="d-flex align-items-center w-100" style="max-width: 250px;">
          <i class="ri-file-info-line fs-3" style="color: #1C274C;"></i>

          <span class="ms-2 text-truncate d-inline-block" style="max-width: 180px;">
            {{ file.name }}
          </span>
        </div>


        <div class="d-flex">

          <button class="btn btn-link text-dark m-0 p-0 mx-2" (click)="viewFile(file)">

            <i class="ri-eye-line fs-18"></i>

          </button>

          <button class="btn btn-link text-dark m-0 p-0" (click)="downloadFile(file)">

            <i class="ri-download-2-line fs-18" style="color: #1C274C;"></i>

            <ng-container *ngIf="isHttpRequestInProgress">

              <span class="spinner-border flex-shrink-0 ms-2" role="status">

                <span class="visually-hidden">Loading...</span>

              </span>

            </ng-container>

          </button>

        </div>

      </div>

    </div>

  </ng-container>
  <app-file-loader *ngIf="isLoading$ | async"></app-file-loader>
</div>